<template>
    <v-dialog v-model="esActiva" persistent >
        <v-container
          class=" px-0 py-0"          
        >
          <v-row
            align="center"
            justify="center" 
           >
            <v-progress-circular 
           
              class="loader"
              indeterminate 
              size="80" 
              color="primary"
            ></v-progress-circular>                      
          </v-row>
        </v-container>
    </v-dialog>  
</template>

<script>
export default {
    props:{
        esActiva: Boolean,
    },
}
</script>
<style scoped>
    .loader{
        position:fixed !important;
        z-index:100;
    }
</style>